<script type="text/jsx">
import mixin from '@/plans/mx/shopping-cart';
import EventCartMixin from '@/plans/EVENT_SAAS/cart';
import planCommonMixin from '@/plans/EVENT_SAAS_CORE/mixin';

export default {
  mixins: [mixin, EventCartMixin, planCommonMixin],
};
</script>
